<template>
  <div class='SideBottom'
  :style="{ 
    backgroundColor: Prefes.nave.corBackground,
    fontFamily: Prefes.nave.font,
    color: Prefes.nave.corFont,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
  }"
  >
    <div class="cont-btn">
      <div class="btn" @click="$router.push('/loja')">
        <div class="icon"><store-icon01 tam="30px" :color="Prefes.nave.corFont"/></div>
        <div class="label">{{ Empresa.modelo === 'Modelo 03' ? 'Imóveis' : 'Produtos' }}</div>
      </div>
    </div>
    <div class="cont-btn">
      <div class="btn" @click="ToggleSearch01(true)">
        <div class="icon"><search-icon width="30px" :color="Prefes.nave.corFont"/></div>
        <div class="label acerto">Procurar</div>
      </div>
    </div>
    <div class="cont-btn">
      <div class="btn" @click="$router.push('/likes')">
        <div class="icon"><heart-icon :color="Prefes.nave.corFont"/></div>
        <div class="label">Favoritos</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StoreIcon01 from '@/components/Theme01/Icons/StoreIcon01'
import SearchIcon from '@/components/EnbPainel/Icons/SearchIcon'
import HeartIcon from '@/components/Theme01/Icons/HeartIcon'
export default {
  name: 'SideBottom',
  components: { StoreIcon01, SearchIcon, HeartIcon },
  computed: {
    ...mapGetters(['Prefes', 'Empresa'])
  },
  methods: {
    ...mapActions(['ToggleSearch01'])
  }
}
</script>

<style scoped>
.SideBottom {
  display: none;
  width: 100%;
  height: 10%;
  position: fixed;
  bottom: 0;
  z-index: 9999;
}

.cont-btn {
  width: 33.3%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.acerto {
  margin-top: -5px;
}

.btn {
}

@media screen and (min-width: 500px) {
  .SideBottom {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .SideBottom {
    display: flex;
  }
}
</style>
